import {useDispatch, useSelector} from 'react-redux'
import text from './text.json'
import Box from './Box'
import InfoBox from '../../core/infoBox'
import {logUpgradePlanNavigation} from '../../../stores/customer-settings'
import {Link} from 'react-router-dom'
import {routes} from '../../../routes'
import {PaidIcon} from '../../../icons'
import classNames from 'classnames'

const Additional = ({showInfoBox, isDarkMode}) => {
    const dispatch = useDispatch()
    const additionalData = useSelector(state => state.monitoring.additionalData)
    const data = useSelector(state => state.monitoring.data)

    const postAction = () => {
        dispatch(logUpgradePlanNavigation())
    }

    const getBoxValue = value => {
        return  !data?.length ? text.not_available : ((value % 1 ? Number(value).toFixed(2) : value) + ' ms')
    }

    return (
        <div className={classNames('additional-data-container', {
            dark: isDarkMode
        })}>
            <div className="additional-data">
                <Box title={text.avg_duration} value={getBoxValue(additionalData?.avg_duration)}
                    className={classNames('avg-duration', {
                        dark: isDarkMode
                    })}/>
                <Box title={text.max_duration} value={getBoxValue(additionalData?.max_duration)}
                    className={classNames('max-duration', {
                        dark: isDarkMode
                    })}/>
                <Box title={text.min_duration} value={getBoxValue(additionalData?.min_duration)}
                    className={classNames('min-duration', {
                        dark: isDarkMode
                    })}/>
                <Box title={text.state_changed_count} value={additionalData?.state_changed_count || 0}
                    className={classNames('changed-count', {
                        dark: isDarkMode
                    })}/>
            </div>
            <InfoBox description={showInfoBox &&
                <span><PaidIcon/> For additional regions and status codes returned during checks, please <Link
                    to={routes.plans.path} onClick={postAction}>upgrade your plan.</Link></span>}>
                <span dangerouslySetInnerHTML={{__html: text.additional_info}}/>
            </InfoBox>
        </div>
    )
}

export default Additional
